export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4703.d45814d3.jpg";